export default {
    // ОБЛОЖКИ
    cover_brazil_1: {
        grade: 1, type: 'paint', subtype: 'cover', src: `/../images/ver2/scores/paint/cover_brazil_1.png`,
        title: 'Обложка Brazil',
        discription: 'Стандартные зелёные обложки с флагом Бразилии'
    },
    cover_brazil_2: {
        grade: 2, type: 'paint', subtype: 'cover', src: `/../images/ver2/scores/paint/cover_brazil_2.png`,
        title: 'Обложка Brazil',
        discription: 'Стандартные синие обложки с флагом Бразилии'
    },
    cover_brazil_3: {
        grade: 3, type: 'paint', subtype: 'cover', src: `/../images/ver2/scores/paint/cover_brazil_3.png`,
        title: 'Обложка Brazil',
        discription: 'Продвинутые красные обложки с флагом Бразилии'
    },
    cover_trefa_2: {
        grade: 2, type: 'paint', subtype: 'cover', src: `/../images/ver2/scores/paint/cover_trefa_2.png`,
        title: 'Обложка Trefas',
        discription: 'Яркие обложки Trefas groupo!'
    },
    cover_flowers_3: {
        grade: 3, type: 'paint', subtype: 'cover', src: `/../images/ver2/scores/paint/cover_flowers_3.png`,
        title: 'Весенние обложки',
        discription: 'Цветастые обложки, наполненные духом и красками высны!'
    },
    cover_cip2025_3: {
        grade: 3, type: 'paint', subtype: 'cover', src: `/../images/ver2/scores/paint/cover_cip2025_3.png`,
        title: 'Обложки ЧР красные',
        discription: 'Обложки для поддержавших донатом Абсолютку ЧР'
    },
    cover_cip2026b_3: {
        grade: 3, type: 'paint', subtype: 'cover', src: `/../images/ver2/scores/paint/cover_cip2026b_3.png`,
        title: 'Обложки ЧР синие',
        discription: 'Обложки для поддержавших донатом Абсолютку ЧР'
    },
    cover_cip2026g_3: {
        grade: 3, type: 'paint', subtype: 'cover', src: `/../images/ver2/scores/paint/cover_cip2026g_3.png`,
        title: 'Обложки ЧР зелёные',
        discription: 'Обложки для поддержавших донатом Абсолютку ЧР'
    },
    cover_africa_black: {
        grade: 3, type: 'paint', subtype: 'cover', src: `/../images/ver2/scores/paint/cover_africa_black.png`,
        title: 'Обложка Африка Черная',
        discription: 'Обложки в рамках ивента Африка на портале 2025'
    },
    cover_africa_red: {
        grade: 3, type: 'paint', subtype: 'cover', src: `/../images/ver2/scores/paint/cover_africa_red.png`,
        title: 'Обложка Африка Красная',
        discription: 'Обложки в рамках ивента Африка на портале 2025'
    },
}